export default {
  redesign: {
    light: {
      redesignBlack: '#29292f',
      redesignMainBlack: '#212121',
      redesignBackground: '#f1f2f6',
      redesignPrimary: '#8783d1',
      redesignPrimaryDarken: '#5542af',
      redesignWarning: '#ffbe0b',
      redesignSuccess: '#018786',
      redesignInfo: '#2aabee',
      redesignError: '#cd6167',
      redesignPrimaryLighten: '#cbc9ec',
      redesignSecondary: '#6a6a71',
      redesignDisabledText: '#c7c6ce',
      redesignControlsBackground: '#ffffff',
      redesignControlsBackgroundAlternative: '#f5f5f5',
      redesignYellowDarken: '#FFA849',
      redesignBorderColor: '#EDEDED',
      redesignMediumGray: '#A8A8B0',
    },

    dark: {
      redesignBlack: '#dadae0',
      redesignMainBlack: '#dadae0',
      redesignBackground: '#2e2e2e',
      redesignPrimary: '#8783d1',
      redesignPrimaryDarken: '#8379db',
      redesignWarning: '#ffbe0b',
      redesignSuccess: '#018786',
      redesignInfo: '#2aabee',
      redesignError: '#cd6167',
      redesignPrimaryLighten: '#5A5969',
      redesignSecondary: '#898991',
      redesignDisabledText: '#747478',
      redesignControlsBackground: '#1e1e1e',
      redesignControlsBackgroundAlternative: '#1a1a1c',
      redesignYellowDarken: '#FFA849',
      redesignBorderColor: '#EDEDED',
      redesignMediumGray: '#A8A8B0',
    },
  },
  uiTheme: {
    /** Условно разделю,
     * lighen/darken: {
     *  1: 60-100%,
     *  2: 30-60%,
     *  3: 10-30%,
     *  4: 0-10%, << это обычно "disabled"
     * }
     */
    light: {
      'ui-primary': {
        base: '#6059EE',
        lighten3: '#cfcdfa', // rgba(96, 89, 238, 0.30)
        lighten4: '#efeefd', // rgba(96, 89, 238, 0.10)
      },
      'ui-background': {
        base: '#F4F4F4',
      },
      'ui-bright': {
        base: '#FFFFFF',
        darken1: '#F4F4F4', // rgba(255, 255, 255, 0.70)
      },
      'ui-neutral': {
        base: '#0F172A',
        lighten1: '#6f747f', // rgba(15, 23, 42, 0.60)
        lighten2: '#9fa2aa', // 'rgba(15, 23, 42, 0.40)',
        lighten3: '#d4d8e1', // 'rgba(15, 23, 42, 0.20)',
        lighten4: '#e7e8ea', // 'rgba(15, 23, 42, 0.10)',
      },
      'ui-success': {
        base: '#06A377',
        lighten3: '#b4e3d6', // 'rgba(6, 163, 119, 0.30)',
        lighten4: '#e6f6f1', // 'rgba(6, 163, 119, 0.10)',
      },
      'ui-warning': {
        base: '#FFBE0B',
        lighten4: '#fff9e7', // 'rgba(255, 190, 11, 0.10)',
      },
      'ui-error': {
        base: '#E33057',
        lighten4: '#fceaee', // 'rgba(227, 48, 87, 0.10)',
      },
      'ui-info': {
        base: '#4369FF',
        lighten4: '#ecf0ff',
      },
    },
    dark: {
      'ui-primary': '#6059EE',
      'ui-background': '#F4F4F4',
      'ui-bright': '#FFFFFF',
      'ui-neutral': '#0F172A',
      'ui-success': '#06A377',
      'ui-warning': '#FFBE0B',
      'ui-error': '#E33057',
    },
  },
};
